import firstStepImage from './assets/steps/1.png';
import secondStepImage from './assets/steps/2.png';
import thirdStepImage from './assets/steps/3.png';
import fourthStepImage from './assets/steps/4.png';

export const instructionsCollection = [
  {
    key: 1,
    image: firstStepImage.src,
    title: 'Issuer sets up an InvestorSet',
    description: `
      It will contain all final transaction documentation and ongoing remittance reports.
    `,
  },
  {
    key: 2,
    image: secondStepImage.src,
    title: 'Issuer approves an investor whitelist',
    description: `
      It includes the most active institutional investors, enabling InvestorSet to provide immediate
      access to listed investors without prior authorization.
    `,
  },
  {
    key: 3,
    image: thirdStepImage.src,
    title: 'Investors request access to a deal',
    description: `
      If whitelisted, access is automatically granted.
      If not on the whitelist, InvestorSet’s fanatical 24x7 support will seek timely approval from the issuer.
    `,
  },
  {
    key: 4,
    image: fourthStepImage.src,
    title: 'Access granted',
    description: `
      Market participants will receive ongoing access and upload notifications. Capital markets bliss is achieved.
    `,
  },
];
